import { pushNewView, updateSelectedCalendarEvent } from '../actions/timePanelStoreActions';
import { orchestrator } from 'satcheljs';
import { clickCalendarEvent, doubleClickCalendarEvent, openComposeView } from 'owa-calendar-list';
import { lazyShowQuickCompose } from 'owa-calendar-compose-form-store/lib/quickCompose/quickComposeIndex';

export const clickCalendarEventOrchestrator = orchestrator(clickCalendarEvent, actionMessage => {
    const { id } = actionMessage;
    updateSelectedCalendarEvent(id);
    pushNewView('EventDetails');
});

export const doubleClickCalendarEventOrchestrator = orchestrator(
    doubleClickCalendarEvent,
    actionMessage => {
        const { id } = actionMessage;
        updateSelectedCalendarEvent(id);
        pushNewView('EventDetails');
    }
);

export const openComposeViewOrchestrator = orchestrator(openComposeView, actionMessage => {
    pushNewView('ComposeForm');
    lazyShowQuickCompose.importAndExecute(
        null /* anchor */,
        'TimePanel' /* entrySource */,
        'TimePanel' /* viewType */,
        actionMessage.event
    );
});
